import {Component, OnInit} from '@angular/core';
import {ImportEntriesFormComponent, ImportProductsFromCsvService} from "@spartacus/cart/import-export/components";
import {FilesFormValidators, ImportCsvFileService, LaunchDialogService} from "@spartacus/storefront";
import {ImportExportConfig} from "@spartacus/cart/import-export/core";
import {GonvarriImportCartEntriesAdapter} from "../../core/adapters/gonvarri-import-cart-entries.adapter";
import {ImportCsv} from "../../core/interfaces/ImportCsv";
import {Observable} from "rxjs";
import {GlobalMessageService, GlobalMessageType} from "@spartacus/core";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'cx-import-entries-form',
  standalone: false,
  templateUrl: './gonvarri-import-entries-form.component.html',
  styleUrl: './gonvarri-import-entries-form.component.scss'
})
export class GonvarriImportEntriesFormComponent extends ImportEntriesFormComponent implements OnInit {

  protected importCsvData$!: Observable<ImportCsv>;
  protected loading: boolean = false;

  constructor(
    launchDialogService: LaunchDialogService,
    importToCartService: ImportProductsFromCsvService,
    importCsvService: ImportCsvFileService,
    filesFormValidators: FilesFormValidators,
    importExportConfig: ImportExportConfig,
    protected globalMessageService: GlobalMessageService,
    protected importCartEntriesAdapter: GonvarriImportCartEntriesAdapter
  ) {
    super(launchDialogService, importToCartService, importCsvService, filesFormValidators, importExportConfig);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.loading = false;
    this.form = this.buildForm();
    this.importCsvData$ = this.importCartEntriesAdapter
      .getTemplateFile();
  }

  onFormSubmit(): void {
    this.loading = true;

    const file: File = this.form.get('file')?.value?.[0];

    this.importCartEntriesAdapter
      .postExcelFile(file)
      .subscribe(() => {
        this.globalMessageService.add({
          key: 'importEntriesDialog.fileUploaded'
        }, GlobalMessageType.MSG_TYPE_CONFIRMATION)
        this.launchDialogService.closeDialog("File uploaded");
      });
  }

  downloadFile(link: string): void {
    const fullLink = this.getOccUrl() + link;
    // Cria um elemento <a> invisível
    const anchor = document.createElement("a");
    anchor.href = fullLink;
    anchor.target = "_blank"; // Abre em nova aba
    anchor.rel = "noopener noreferrer"; // Boa prática de segurança
    anchor.style.display = "none"; // Torna invisível
    // Adiciona ao DOM
    document.body.appendChild(anchor);
    // Dispara o clique programaticamente
    anchor.click();
    // Remove o elemento após o uso (opcional)
    document.body.removeChild(anchor);
  }

  protected override buildForm(): UntypedFormGroup {
    const form = new UntypedFormGroup({});
    form.setControl(
      'file',
      new UntypedFormControl(
        '',
        [Validators.required, this.filesFormValidators.maxSize(this.maxSize)],
      )
    );
    return form;
  }

  public override get allowedTypes(): string[] | undefined {
    console.log(this.importExportConfig.cartImportExport?.import?.fileValidity?.allowedTypes);
    return [
      ".xlsx"
    ];
  }

  getOccUrl(): string {
    const metaTag = document.querySelector('meta[name="occ-backend-base-url"]') as HTMLMetaElement;
    return metaTag.content;
  }

  getFormControl(data: any): any {
    return data;
  }

}
